import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=0009a09d&scoped=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./ButtonComponent.vue?vue&type=style&index=0&id=0009a09d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0009a09d",
  null
  
)

export default component.exports